<template>
    <div>
        <!-- <el-alert title="请制作自己的视频，如需制作他人视频，请联系作者授权" type="warning" v-if="hide_ts!=1" style="margin-bottom: 10px;">
        </el-alert> -->
        <div
            style="display: flex;align-items: center;border-radius: 7px;justify-content: space-between;flex-wrap: wrap;padding: 0px;">
            <div style="display: flex;align-items: center;flex-wrap: wrap;">
                <!-- <el-tag size="medium" v-if="user_list.type == 2 || user_list.type == 3"
                    :type="(user_list.surplus == '已过期' ? 'danger' : '')">
                    <i class="el-icon-coin"></i>月卡:{{
                    user_list.surplus
                    }}
                </el-tag> -->
                <el-tag size="medium" type="success">
                    <i class="el-icon-scissors"></i>
                    可用余额:{{ this.user_list.surplus }}<i class="el-icon-loading"
                        v-if="!this.user_list.surplus"></i>点</el-tag>
                <el-tag size="medium" v-if="user_list.surplus_timestamp">
                    <i class="el-icon-coin"></i>到期时间:{{ user_list.surplus_timestamp }}
                    <i class="el-icon-loading" v-if="!user_list.surplus_timestamp"></i>
                </el-tag>
                <!-- <el-tag size="medium">
                    <i class="el-icon-coin"></i>限制使用:{{ user_list.limitnum }}
                </el-tag> -->

                <el-tag size="medium" type="danger" v-if="fwq"><i class="el-icon-star-on"></i>独立通道</el-tag>
            </div>
            <div v-if="pd.zs > 0">
                <el-tag type="success" v-if="pd.zt == 1" size="medium">
                    制作中您在第{{ pd.wz }}位 共{{ pd.zs }}个任务
                </el-tag>
                <el-tag type="info" v-else size="medium">
                    官网{{ pd.zs }}个任务在制作
                </el-tag>
            </div>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    props: ["hide_ts"],
    // 定义属性
    data() {
        return {
            user_list: [],
            calltoday: 0,
            surplus: 0,
            hz: 0,
            limitnum: 0,
            pd: [],
            fwq: ''
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        get_user() {

            this.$ajax.get('qhy/user/balance').then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.user_list = jg.data
                    this.calltoday = jg.data.calltoday
                    this.limitnum = jg.data.limitnum
                    this.fwq = jg.data.fwq

                    this.hz = jg.data.hz
                    this.pd = jg.pd

                    this.$emit('upload-tutorial', jg.data.upload_tutorial)

                    if (jg.pd.wz == 0) {
                        this.cleartime = 1
                    } else {
                        this.cleartime = 0
                    }
                    window.sessionStorage.setItem('userinfo', JSON.stringify(jg.data))
                    // this.$msg.success(res.data.msg)
                } else {
                    // this.$router.push('/login')
                }

            })
        },
        jsq() {
            this.cleartime = 0
            this.timer = setInterval(() => {
                // console.log('排队计时器', this.$callrecord.status)
                // if (this.cleartime == 2) {
                //     clearInterval(this.timer);
                //     this.timer = null;
                //     this.$callrecord = 0
                // }
                if (this.cleartime == 0) {
                    this.get_user()
                    this.$set(this.$callrecord, 'status', 1)
                } else {
                    this.$set(this.$callrecord, 'status', 0)
                }
            }, 5000)
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.get_user()
        this.jsq()
        // this.dsq_time = this.common.time_10() + 1800//定时30分钟无操作清除定时器
        // this.cleartime = 0
        // this.timer = setInterval(() => {
        //     // console.log('计时器')
        //     if (this.cleartime == 1 || this.dsq_time < this.common.time_10()) {
        //         clearInterval(this.timer);
        //         this.timer = null;
        //     } else {
        //         this.get_user()
        //     }

        // }, 5000)

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { this.cleartime = 2 }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.el-tag {
    margin: 4px 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Balance.vue


// WEBPACK FOOTER //
// src/components/User/Balance.vue